export default __webpack_public_path__ + "static/media/arrow-right-search.deaa7881.svg";